export const coachConstants = {
    COACH_SUBSCRIPTION: 'COACH_SUBSCRIPTION',
    COACH_SUBSCRIPTION_FAILURE: 'COACH_SUBSCRIPTION_FAILURE'
};
